import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { KeycloakAuthService } from './keycloak-auth.service';

/**
 * HTTP Interceptor that attaches authentication tokens to API requests.
 *
 * Local Development (Keycloak disabled):
 * - Attaches host application tokens from post-robot messaging
 * - API middleware is disabled, but tokens are still attached for testing
 *
 * Production (Keycloak enabled):
 * - Attaches Keycloak JWT tokens to all API requests
 * - Tokens are validated by API middleware (HybridOpenIdMfmAuthenticationMiddleware)
 */
export const keycloakAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloakAuthService = inject(KeycloakAuthService);

  if (!keycloakAuthService.shouldAttachToken(req.url)) {
    return next(req);
  }

  return from(keycloakAuthService.getValidToken()).pipe(
    tap((token) => {
      if (!token && keycloakAuthService.shouldAttachToken(req.url)) {
        console.debug(`[Auth] No token available for request to ${req.url}`);
      }
    }),
    switchMap((token) => {
      if (!token) {
        return next(req);
      }

      console.debug(`[Auth] Attaching bearer token to request: ${req.url}`);
      return next(
        req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        })
      );
    })
  );
};